import { Link } from 'react-router-dom'
import { FaInstagram, FaTiktok } from 'react-icons/fa'

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          {/* Logo & Brand */}
          <div className="lg:col-span-1">
            <Link to="/marketplace" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-brand-primary flex items-center justify-center text-white shadow-md">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zM10 17l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                </svg>
              </div>
              <span className="text-xl font-bold text-white">certi</span>
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed">
              Authentic sports memorabilia marketplace
            </p>
          </div>

          {/* Certi */}
          <div>
            <h3 className="text-white font-semibold mb-4">Certi</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/how-it-works" className="text-sm hover:text-brand-primary transition-colors">
                  About us
                </Link>
              </li>
              <li>
                <a href="mailto:contact@certiauthentic.com" className="text-sm hover:text-brand-primary transition-colors">
                  Partnerships
                </a>
              </li>
              <li>
                <Link to="/news" className="text-sm hover:text-brand-primary transition-colors">
                  News
                </Link>
              </li>
            </ul>
          </div>

          {/* Learn more */}
          <div>
            <h3 className="text-white font-semibold mb-4">Learn more</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/how-it-works" className="text-sm hover:text-brand-primary transition-colors">
                  How it works
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-sm hover:text-brand-primary transition-colors">
                  Authentication
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-white font-semibold mb-4">Customer Service</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/how-it-works" className="text-sm hover:text-brand-primary transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <a href="mailto:contact@certiauthentic.com" className="text-sm hover:text-brand-primary transition-colors">
                  Email us
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-white font-semibold mb-4">Connect</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://www.instagram.com/certiauthentic/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-brand-primary transition-colors flex items-center gap-2"
                >
                  <FaInstagram className="w-4 h-4" />
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.tiktok.com/@certiauthentic"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-brand-primary transition-colors flex items-center gap-2"
                >
                  <FaTiktok className="w-4 h-4" />
                  TikTok
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} certi. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-sm text-gray-500 hover:text-brand-primary transition-colors">
                Privacy Policy
              </Link>
              <Link to="/return-policy" className="text-sm text-gray-500 hover:text-brand-primary transition-colors">
                Return Policy
              </Link>
              <Link to="/terms" className="text-sm text-gray-500 hover:text-brand-primary transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
